<template>
  <div class="detailContainer">
    <div class="tit">
      {{ formData.informationTitle }}
      <!--<span>“成长之星”奖</span>-->
    </div>
    <div class="buniness">
      <div class="bun_left">
        <img :src="logoSrc" alt="" />
        <span class="desc">
          <p class="bun_name">{{ formData.userName }}</p>
          <p class="num">{{ formData.createdon }}</p>
        </span>
      </div>
      <div class="btn_dynamic">咨讯中心</div>
    </div>
    <ul class="txt_desc">
      <li>
        <div class="imgs">
          <img :src="formData.informationTitleImage" alt="" />
        </div>
        <p v-html="formData.informationContent">
          <!-- {{item.txt}} -->
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        logoSrc: require('@/assets/consulte/logo.png'),
        formData: {

        }
      }
    },
    mounted() {
      if (this.$route.query.informationId) {
        this.newsDetail(this.$route.query.informationId)
      } 
    },
    methods: {
      async newsDetail(informationId) {
        const data = await this.$api.getInformationId(informationId)
        if (data.success) {
          this.formData = data.datas.content
        }
      },

    }
  }
</script>
<style>
  body {
    background: #fff;
  }
</style>
<style lang="scss" scoped>
  .detailContainer {
    box-sizing: border-box;
    padding: 0 15px;
    .tit {
      font-size: 22px;
      color: #2c2e34;
      line-height: 31px;
      margin-top: 15px;
      box-sizing: border-box;
      padding-right: 5px;
    }
    .buniness {
      height: 40px;
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      .bun_left {
        width: 200px;
        height: 100%;
        display: flex;
        img {
          width: 30px;
          height: 35px;
          margin-right: 10px;
        }
        .desc {
          .bun_name {
            font-size: 14px;
            color: #2c2e34;
            margin: 3px 0 3px;
          }
          .num {
            font-size: 12px;
            color: #777e88;
            white-space: nowrap;
          }
        }
      }
      .btn_dynamic {
        width: 80px;
        height: 28px;
        font-size: 14x;
        color: #00b38a;
        background: rgba(0, 179, 138, 0.13);
        border: 1px solid #00b38a;
        border-radius: 5.5px;
        text-align: center;
        line-height: 26px;
      }
    }
    .txt_desc {
      width: 100%;
      li {
        margin-bottom: 20px;
        p {
          font-size: 17px;
          color: #2c2e34;
          letter-spacing: 0;
          line-height: 28px;
        }
        .imgs {
          width: 100%;
          height: 178px;
          // border-radius: none;
          margin-top: 18px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      img {
        width: 100% !important;
      }
      // :last-child{
      //     margin-bottom: 0;
      // }
    }
    .conclusion {
      font-size: 17px;
      color: #2c2e34;
      line-height: 28px;
      .con_last {
        margin-top: 15px;
      }
    }
  }
</style>
